'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { Calendar as CalendarIcon } from '@ethsign/icons';
import dayjs from 'dayjs';
import * as React from 'react';
import { Button } from "../Button";
import { Popover, PopoverContent, PopoverTrigger } from "../Popover/popover";
import { cn } from "../lib/utils";
import { Calendar } from "./calendar";
export var DatePicker = function DatePicker(props) {
  var value = props.value,
    onChange = props.onChange,
    className = props.className,
    placeholder = props.placeholder,
    disabled = props.disabled,
    calendarProps = props.calendarProps,
    format = props.format,
    autoHidden = props.autoHidden,
    renderValue = props.renderValue;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  return /*#__PURE__*/React.createElement(Popover, {
    open: open,
    onOpenChange: setOpen
  }, /*#__PURE__*/React.createElement(PopoverTrigger, {
    asChild: true
  }, /*#__PURE__*/React.createElement(Button, {
    variant: 'outline',
    className: cn('w-[240px] justify-between text-left font-normal shadow-xs', !value && 'text-muted-foreground', className),
    disabled: disabled
  }, value ? renderValue ? renderValue(value) : dayjs(value).format(format || 'MMMM DD, YYYY') : /*#__PURE__*/React.createElement("span", null, placeholder || 'Pick a date'), /*#__PURE__*/React.createElement(CalendarIcon, {
    className: "ml-2 h-4 w-4",
    color: '#98A2B3'
  }))), /*#__PURE__*/React.createElement(PopoverContent, {
    className: "w-auto p-0",
    align: "start"
  }, /*#__PURE__*/React.createElement(Calendar, _extends({
    mode: "single",
    selected: value,
    onSelect: function onSelect(date) {
      if (onChange) {
        onChange(date);
      }
      if (autoHidden) {
        setOpen(false);
      }
    },
    initialFocus: true
  }, calendarProps))));
};
export { Calendar };